import React, { forwardRef } from 'react';

import { GENDER_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { useFormContext } from 'react-hook-form';

import st from '../popovers.module.sass';

function GenderFilterPopover(
  {
    name = 'gender',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { control } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <ControllableOptionsFilter
        control={control}
        isSearchable={false}
        name={name}
        options={GENDER_OPTIONS.raw}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const GenderFilterPopoverWithRef = forwardRef(GenderFilterPopover);
export { GenderFilterPopoverWithRef as GenderFilterPopover };
